import {FC, useState} from 'react'
import {KTSVG} from '../../../../../../../../../../../_metronic/helpers'
import {ModalEditContractPayment} from '../../components/modal/ModalEditContractPayment'
import {PaymentHistory} from '../../core/_models'

type Props = {
  PaymentHistory: PaymentHistory
}
const PaymentHistoryActionsCell: FC<Props> = ({PaymentHistory}) => {
  const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false)

  return (
    <>
      <button
        title='Editar'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        onClick={() => setShowPaymentModal(true)}
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_edit_payment'
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
      </button>
      <ModalEditContractPayment
        id='propertiesRegistriesEdit'
        show={showPaymentModal}
        handleClose={() => setShowPaymentModal(false)}
        uuidRow={PaymentHistory.uuid}
        uuidContract={PaymentHistory.contract?.uuid}
      />
    </>
  )
}

export {PaymentHistoryActionsCell}
